<template>
<p class="important-line">
  {{ value}}
</p>
</template>
<script>
export default {
}
</script>



// WEBPACK FOOTER //
// ImportantLine.vue?972c464a